import { readUnhandledEnumCase, unhandledEnumCase } from 'rpc-client-utils';
import getLang from '../utils/getLang';

export const ACADEMY_SUPPORTED_LANGUAGES = [
  'EN',
  'ES',
  'DE',
  'JA',
  'FR',
  'PT',
] as const;

function toLowerCaseTuple<T extends readonly string[]>(
  arr: T
): { [K in keyof T]: Lowercase<T[K]> } {
  return arr.map((language) => language.toLowerCase()) as {
    [K in keyof T]: Lowercase<T[K]>;
  };
}

export const supportedPublicLanguages = toLowerCaseTuple(
  ACADEMY_SUPPORTED_LANGUAGES
);

export type SupportedPublicLanguage = (typeof supportedPublicLanguages)[number];

export type SupportedLanguage =
  | (typeof ACADEMY_SUPPORTED_LANGUAGES)[number]
  | unhandledEnumCase;

export const convertToSupportedLanguage = (
  lang: string | undefined | null
): SupportedLanguage => {
  const upperLang = (lang?.toUpperCase() ?? 'EN') as SupportedLanguage;
  return ACADEMY_SUPPORTED_LANGUAGES.includes(
    upperLang as (typeof ACADEMY_SUPPORTED_LANGUAGES)[number]
  )
    ? upperLang
    : 'EN';
};

export const getSupportedLanguage = (): SupportedLanguage => {
  return convertToSupportedLanguage(getLang());
};

export const convertToLegacyLanguage = (
  language: SupportedLanguage
): string => {
  return readUnhandledEnumCase(language).toLowerCase();
};

export const fullLanguageNameToCode = (
  langName: string
): string | undefined => {
  switch (langName) {
    case 'english':
      return 'en';
    case 'french':
      return 'fr';
    case 'german':
      return 'de';
    case 'spanish':
      return 'es';
    case 'portuguese':
      return 'pt';
    case 'japanese':
      return 'ja';
    default:
      return undefined;
  }
};
